import OnlineUserListComponent from './online-user-list.vue';

export const OnlineUserListComponentInstall = (Vue) => {
  const Constructor = Vue.extend(OnlineUserListComponent);
  Vue.component('online-user-list', Constructor);
}

import OnlineUserVideoComponent from './online-user-video.vue';

export const OnlineUserVideoComponentInstall = (Vue) => {
  const Constructor = Vue.extend(OnlineUserVideoComponent);
  Vue.component('online-user-video', Constructor);
}


